const initState = {
  info: [],
  currentPost: {},
};

const GalleryPosts = (state = initState, action) => {
  switch (action.type) {
    case "SET":
      const temp = state;
      temp.info = action.payload;
      return temp;
    case "ADD":
      state.info.push(action.payload);
      return state;
    case "SET_POST":
      state.currentPost = action.payload;
      return state;
    case "DEL_POST":
      state.currentPost = {};
      return state;
    case "CLEAR":
      state.info = [];
      state.currentPost = {};
      return state;
    case "RESET":
      state = initState;
      return state;
    default:
      return state;
  }
};

export default GalleryPosts;
